import React from "react";
import { useNavigate } from "react-router-dom";
import { Building2, Check, ChevronDown, Plus } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../lib/i18n.jsx";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
  DropdownMenuSeparator, DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export const CompanySwitcher = () => {
  const { user, switchCompany, can } = useAuth();
  const { t, tn } = useI18n();
  const nav = useNavigate();
  const companies = user?.companies || [];
  const label = tn(user?.company?.app_name || user?.company?.name || "KONVIA");

  const onSwitch = async (c) => {
    if (c.company_id === user.company_id) return;
    try {
      await switchCompany(c.company_id);
      toast.success(`${t("switched_to")}: ${c.name}`);
      nav("/dashboard");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error");
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="company-switcher" className="flex items-center gap-1.5 font-display font-bold text-lg truncate hover:text-[var(--amber)] transition-colors">
          <span className="truncate">{label}</span>
          {companies.length > 1 && <ChevronDown size={16} className="shrink-0 text-slate-400" />}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <DropdownMenuLabel>{t("my_companies")}</DropdownMenuLabel>
        {companies.map((c) => (
          <DropdownMenuItem key={c.company_id} data-testid={`company-option-${c.company_id}`}
            onClick={() => onSwitch(c)} className="gap-2 cursor-pointer">
            <Building2 size={16} className="text-slate-400 shrink-0" />
            <span className="truncate flex-1">{c.name}</span>
            {c.company_id === user.company_id && <Check size={16} className="text-[var(--amber)]" />}
          </DropdownMenuItem>
        ))}
        {can("settings.manage") && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem data-testid="add-company-btn" onClick={() => nav("/onboarding")} className="gap-2 cursor-pointer text-[var(--amber)]">
              <Plus size={16} /> {t("add_company")}
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
